import {Component, Input, OnChanges, OnInit, SimpleChanges, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import * as _ from 'underscore';
import moment from 'moment';
import { ChartOptions } from 'chart.js';

@Component({
    selector: 'app-derivatives-vs-collateral-chart',
    templateUrl: './derivatives-vs-collateral-chart.component.html',
    styleUrls: ['./derivatives-vs-collateral-chart.component.scss'],
    standalone: false
})
export class DerivativesVsCollateralChartComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    derivativesVsCollateralChartData: any[];

    @Input()
    periodLength?: string;

    eceMaxObject: any = {
        maxObj: null,
        maxType: null
    };

    public lineChartOptions: any = {
        // We use these empty structures as placeholders for dynamic theming.
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                type: 'time',
                time: {
                    displayFormats: {
                        quarter: 'MMM YYYY'
                    }
                },
                grid: {
                    display: false
                }
            }, 
            der: {
                id: 'der',
                position: "left",
                max: 590,
                min: -80,
                grid: {
                    display: false
                },
                ticks: {
                    includeBounds: true,
                    
                    stepSize: 25,
                    padding: 5,
                    callback: function (value: number, index, labelArray) {
                        return -1 * value;
                    }
                }
            },
            col: {
                id: 'col',
                max: 885,
                min: -120,
                position: "right",
                grid: {
                    display: false
                },
                ticks: {
                    includeBounds: true,
                    
                    stepSize: 25,
                    padding: 5,
                }
            },
        },
        plugins: {
            legend: {
                display: true,
                labels: {
                    usePointStyle: true,
                  },
            }
        },
    };

    public chartOptions: any = {
        name: 'derivativeVsCollateralChart',
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            position: 'top',
            labels: {
                usePointStyle: true
            }
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItems) {
                    if (tooltipItems.datasetIndex === 0) {
                        return -1 * tooltipItems.yLabel;
                    }
                    return tooltipItems.yLabel;
                }
            },
            position: 'average',
            mode: 'index',
            intersect: false
        },
        scales: {
            xAxes: [{
                type: 'time',
                distribution: 'linear',
                time: {
                    unit: 'month',
                    stepSize: 1,
                    tooltipFormat: 'll',
                    displayFormats: {
                        month: 'MMM YYYY'
                    }
                },
                gridLines: {
                    drawOnChartArea: false,
                    tickMarkLength: 3
                },
                ticks: {
                    fontSize: 11
                }
            }],
            yAxes: [{
                id: 'der',
                position: 'left',
                ticks: {
                    padding: 5,
                    fontSize: 11,
                    callback: function (value, index, labelArray) {
                        return -1 * value;
                    }
                },
                gridLines: {
                    display: true,
                    drawTicks: true,
                    drawOnChartArea: false,
                    tickMarkLength: 3
                }
            }, {
                id: 'col',
                position: 'right',
                ticks: {
                    padding: 5,
                    fontSize: 11
                },
                gridLines: {
                    display: true,
                    drawTicks: true,
                    drawOnChartArea: false,
                    tickMarkLength: 3
                }
            }]
        }
    };
    public chartLabels: number[] = [0, 0.5, 1, 2, 3, 4, 5, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 39, 42, 45, 48, 51, 54, 57, 60, 63, 66,
        69, 72, 75, 78, 81, 84, 87, 90, 93, 96, 99, 102, 105, 108, 111, 114, 117, 120];
    public dateFormatLabels: Date[] = [];
    public chartType = 'line';


    public chartData: any[] = [];


    colorArray = [{
        backgroundColor: '#c80001',
        hoverBackgroundColor: '#c80001',
        borderColor: '#c80001',
        hoverBorderColor: '#c80001'
    }, {
        backgroundColor: '#008c35',
        hoverBackgroundColor: '#008c35',
        borderColor: '#008c35',
        hoverBorderColor: '#008c35'
    }, {
        backgroundColor: 'rgba(8, 122, 99, 0.4)',
        hoverBackgroundColor: 'rgba(8, 122, 99, 0.4)',
        borderColor: 'rgba(8, 122, 99, 0.4)',
        hoverBorderColor: 'rgba(8, 122, 99, 0.4)'
    }, {
        backgroundColor: 'rgba(219, 30, 57, 0.4)',
        hoverBackgroundColor: 'rgba(219, 30, 57, 0.4)',
        borderColor: 'rgba(219, 30, 57, 0.4)',
        hoverBorderColor: 'rgba(219, 30, 57, 0.4)'
    }];

    public chartInstance = {
        chart: null
    };

    public chartClicked(e: any): void {

    }

    public chartHovered(e: any): void {
    }

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes.periodLength) {
            return;
        }
        this.createDateFormatLabels(+changes.periodLength.currentValue);
    }

    ngOnInit() {
        this.rotateData();
        this.getYAxisMaxAndMin();
    }

    ngOnDestroy() {
    }

    private rotateData() {
        if (!this.derivativesVsCollateralChartData || this.derivativesVsCollateralChartData.length <= 0) {
            return;
        }
        this.chartData = [];

        let data1 = _.map(this.derivativesVsCollateralChartData, x => x.derMv.toFixed(2));
        let data2 = _.map(this.derivativesVsCollateralChartData, x => x.colMv.toFixed(2));
        if (this.chartLabels.length !== this.derivativesVsCollateralChartData.length) {
            data1 = this.fixMissingTimesteps(this.derivativesVsCollateralChartData, 'derMv');
            data2 = this.fixMissingTimesteps(this.derivativesVsCollateralChartData, 'colMv');
        }
//'#cee4e0' : '#f8d2d7'
        let derSet = this.getChartDataset('Derivatives', data1, 'der', true, 1);
        derSet = {
            ...derSet,
            backgroundColor: '#cee4e0',
            hoverBackgroundColor: '#c80001',
            borderColor: '#c80001',
            pointBorderColor: '#c80001',
            hoverBorderColor: '#c80001'
        }
        this.chartData.push(derSet);
        let dset = this.getChartDataset('Collateral', data2, 'col', true, false);
        dset = {
            ...dset,
            backgroundColor: '#f8d2d7',
            hoverBackgroundColor: '#008c35',
            borderColor: '#008c35',
            pointBorderColor: '#008c35',
            hoverBorderColor: '#008c35'
        }
        this.chartData.push(dset);
        let ECE = {
            ...this.getFakeDatasetForFillLegend('Excess Cred Exp', 'col'),
            backgroundColor: 'rgba(8, 122, 99, 0.4)',
            hoverBackgroundColor: 'rgba(8, 122, 99, 0.4)',
            pointBorderColor: 'rgba(8, 122, 99, 0.4)',
            pointBackgroundColor: 'rgba(8, 122, 99, 0.4)',
            borderColor: 'rgba(8, 122, 99, 0.4)',
            hoverBorderColor: 'rgba(8, 122, 99, 0.4)'
        }
        this.chartData.push(ECE);
        let SCE = {
            ...this.getFakeDatasetForFillLegend('Shortfall in Cred Exp', 'col'),
            backgroundColor: 'rgba(219, 30, 57, 0.4)',
            hoverBackgroundColor: 'rgba(219, 30, 57, 0.4)',
            pointBorderColor: 'rgba(219, 30, 57, 0.4)',
            pointBackgroundColor: 'rgba(219, 30, 57, 0.4)',
            borderColor: 'rgba(219, 30, 57, 0.4)',
            hoverBorderColor: 'rgba(219, 30, 57, 0.4)'
        }
        this.chartData.push(this.getFakeDatasetForFillLegend('Shortfall in Cred Exp', 'col'));
    }

    private getYAxisMaxAndMin() {
        const maxColMv = Math.max(...this.derivativesVsCollateralChartData.map(x => x.colMv.toFixed(0)));
        const maxDerMv = Math.max(...this.derivativesVsCollateralChartData.map(x => x.derMv.toFixed(0)));

        let maxDerMvYAxis = maxDerMv > (maxColMv / 1.5) ? maxDerMv : (maxColMv / 1.5);
        maxDerMvYAxis = this.getNearestZeroBaseValue(+maxDerMvYAxis.toFixed(0));
        const maxColMvYAxis = maxDerMvYAxis * 1.5;

        this.lineChartOptions.scales.der.max = maxDerMvYAxis;
        this.lineChartOptions.scales.col.max = maxColMvYAxis;

        const minColMv = Math.min(...this.derivativesVsCollateralChartData.map(x => x.colMv.toFixed(0)));
        const minDerMv = Math.min(...this.derivativesVsCollateralChartData.map(x => x.derMv.toFixed(0)));

        let minDerMvYAxis = minDerMv < (minColMv / 1.5) ? minDerMv : (minColMv / 1.5);
        minDerMvYAxis = this.getReduceFivePercent(maxDerMvYAxis, minDerMvYAxis);
        const unitIncrease = this.getSingleUnitOfZeroBaseValue(minDerMvYAxis);
        minDerMvYAxis = this.getNearestZeroBaseValue(+(minDerMvYAxis - unitIncrease).toFixed(0));
        const minColMvYAxis = minDerMvYAxis * 1.5;

        this.lineChartOptions.scales.der.min = minDerMvYAxis;
        this.lineChartOptions.scales.col.min = minColMvYAxis;

        const stepSize = this.getStepSize(this.lineChartOptions.scales.der.max, this.lineChartOptions.scales.der.min);
        this.lineChartOptions.scales.der.ticks.stepSize = stepSize;
        this.lineChartOptions.scales.col.ticks.stepSize = stepSize * 1.5;

        const recalculatedDerMin = this.recalculateDerivativeYAxisMin(this.lineChartOptions.scales.der.min, stepSize);
        this.lineChartOptions.scales.der.min = recalculatedDerMin;
        this.lineChartOptions.scales.col.min = recalculatedDerMin * 1.5;

        this.lineChartOptions = Object.assign({}, this.lineChartOptions);
    }

    private getReduceFivePercent(max: number, min: number): number {
        return min - ((max * 5) / 100);
    }

    private getStepSize(max: number, min: number) {
        const numberOfSteps = 8;
        const absoluteValueDifference = Math.abs(max - min);
        return this.getNearestZeroBaseValue(+(absoluteValueDifference / numberOfSteps).toFixed(0));
    }

    private recalculateDerivativeYAxisMin(currentMin: number, stepSize: number) {
        if (0 > currentMin) {
            const val = Math.abs(currentMin) / stepSize;
            return -1 * (Math.round(val) * stepSize);
        }
        return currentMin;
    }

    private getSingleUnitOfZeroBaseValue(value: number): number {
        value = +(value.toFixed(0));
        const length = value.toString().length;
        let str = '1';
        for (let i = 1; i < length - 1; i++) {
            str += '0';
        }

        return (+str);
    }

    private getNearestZeroBaseValue(value: number): number {
        value = +(value.toFixed(0));
        const length = value.toString().length;
        let str = '1';
        for (let i = 1; i < length - 1; i++) {
            str += '0';
        }

        return Math.ceil(value / (+str)) * (+str);
    }

    private createDateFormatLabels(maxLabel: number) {
        let startDate = moment();
        if (this.derivativesVsCollateralChartData && this.derivativesVsCollateralChartData.length > 0) {
            startDate = moment(this.derivativesVsCollateralChartData[0].timeStepDate);
        }

        const indexOfMaxLabel = _.indexOf(this.chartLabels, maxLabel);
        const newChartLabels = this.chartLabels.slice(0, indexOfMaxLabel + 1);
        this.dateFormatLabels = _.map(newChartLabels, x => {
            if (x === 0.5) {
                return startDate.clone().add(15, 'days').toDate();
            }
            return startDate.clone().add(x, 'months').toDate();
        });
    }

    private getChartDataset(key: string, data: any[], yAxisId: string, fillBetweenSet: boolean, fill: boolean | string | number): any {
        const obj: any = {
            label: key,
            fill: fill,
            lineTension: 0.5,
            borderWidth: 1.2,
            pointRadius: 0,
            pointHoverRadius: 3,
            data: data,
            yAxisID: yAxisId,
            pointStyle: 'line',
            target: 1
        };
        if (fillBetweenSet) {
            obj.fillBetweenSet = 1;
        }
        return obj;
    }

    private getFakeDatasetForFillLegend(key: string, yAxisId: string) {
        return {
            label: key,
            fill: false,
            lineTension: 0.5,
            borderWidth: 1.2,
            pointRadius: 2,
            pointHoverRadius: 3,
            data: [],
            yAxisID: yAxisId,
            pointStyle: 'rect'
        };
    }

    private fixMissingTimesteps(data: any[], fieldName: string): any[] {
        return _.map(this.chartLabels, x => {
            if (_.any(data, item => item.timeStep === x)) {
                return _.find(data, y => y.timeStep === x)[fieldName].toFixed(2);
            }
            return 0;
        });
    }
}
